import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PageListWrapper from 'shared/styles/components/PageList';
import TabView from 'shared/ui/tabs/TabView';
import { Tab, ShadowNav } from 'shared/styles/components/Tabs';
import SubscriptionList from './subscriptionOrderList';
import { addNotification, setPageSize } from 'core/redux/ui/actions';
import { LEVELS, createNotification } from 'shared/utilities/notification';
import { ERROR_MESSAGES } from 'shared/constants/messages';
import { ENV_DEFAULT_OPTION } from 'shared/constants/matrixOptions';
import { PAGINATION_DEFAULT_OPTION } from 'shared/constants/pagination';
import SubscriptionDeleteList from './subscriptionOrderDelete';

const subscription = ({ showNotification }) => {
  const [initialPageLoad, setInitialPageLoad] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(ENV_DEFAULT_OPTION);
  const dispatch = useDispatch();
  // reset page size on route change
  useEffect(() => {
    return () => {
      dispatch(setPageSize(PAGINATION_DEFAULT_OPTION));
    };
  }, []);

  return (
    <PageListWrapper>
      <TabView
        tabContainer={ShadowNav}
        tabs={[
          {
            tabElement: <Tab>Show Order</Tab>,
            content: (
              <SubscriptionList
                key={selectedAccount.value}
                initialPageLoad={initialPageLoad}
                setInitialLoads={(state) => setInitialPageLoad(state)}
                showNotification={showNotification}
                selectedAccount={selectedAccount}
                setSelectedAccount={setSelectedAccount}
              />
            ),
          },
          {
            tabElement: <Tab>Delete Order</Tab>,
            content: (
              <SubscriptionDeleteList
                key={selectedAccount.value}
                initialPageLoad={initialPageLoad}
                setInitialLoads={(state) => setInitialPageLoad(state)}
                showNotification={showNotification}
                selectedAccount={selectedAccount}
                setSelectedAccount={setSelectedAccount}
              />
            ),
          },
        ]}
      />
    </PageListWrapper>
  );
};

export default connect(
  (state) => ({}),
  (dispatch) => ({
    showNotification: (e) =>
      dispatch(
        addNotification({
          notification: createNotification(LEVELS.ERROR, ERROR_MESSAGES.FETCH_JOBS, e),
        })
      ),
  })
)(subscription);
